import React, {useState, useContext, useEffect, useReducer} from "react";
import {ToastContainer} from "react-toastify";
import {ThemeProvider as EmotionThemeProvider} from "emotion-theming";
import {StripeProvider} from "react-stripe-elements";
import styled from "@emotion/styled";
import {ThemeProvider} from "styled-components";
import {UserContext} from "@/contexts/user";
import useSWR from "swr";

import Routes from "../Routes";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
const expanded = localStorage.getItem("footer") == "false" ? false : true;

const theme = {
  green: "#0f0",
  mainColor:
    localStorage.getItem("preset") === "Pride"
      ? "-webkit-linear-gradient(top, #FF0018 0, #FF0018 16%, #FFA52C 16%, #FFA52C 33%, #FFFF41 33%, #FFFF41 48%, #008018 48%, #008018 66%, #0000F9 66%, #0000F9 83%, #86007D 83%, #86007D)"
      : localStorage.getItem("mainColor")
      ? localStorage.getItem("mainColor")
      : "#0f0",
  mainTextColor: localStorage.getItem("mainTextColor") ? localStorage.getItem("mainTextColor") : "#3c3c3b",
  secondaryColor: localStorage.getItem("secondaryColor") ? localStorage.getItem("secondaryColor") : "",
  secondaryTextColor: localStorage.getItem("secondaryTextColor") ? localStorage.getItem("secondaryTextColor") : "",

  darkGreen: "#0b0",
  veryDarkGreen: localStorage.getItem("mainTextColor") ? localStorage.getItem("mainTextColor") : "#003b00",
  newGreen: "#62ff86",
  veryLightGrey: "#f6f7f9",
  lightGrey: "#c2cad6",
  grey: "#8595ad",
  darkGrey: "#52627a",
  veryDarkGrey: "#3c3c3b",
  almostBlack: "#212428",
  lightRed: "#FFBDBD",
  red: "#EF4E4E",
  darkRed: "#AB091E",
  monoFont: "'IBM Plex Mono', monospace",
  sansFont: "'IBM Plex Sans', sans-serif",
  shadow: "2px 2px 0px #cdcdcd, -2px -2px 0px #ffffff",
  transition: "all 0.2s ease-in-out",
};

const Layout = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  width: 100%;

  main {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
`;

const headerFetcher = url => fetch(url).then(res => res.json());

export default function App() {
  const {user} = useContext(UserContext);
  const {data: topHeaderData} = useSWR(
    `https://us-central1-hackernoon-app.cloudfunctions.net/app/header-data?path=/`,
    //`http://localhost:8080/header-data${parentCategory ? `?parentCategory=${parentCategory}` : `${path ? `?path=${path}` : ""}`}`,
    headerFetcher,
  );
  let headerData = topHeaderData && topHeaderData?.status === "ok" ? topHeaderData.headerData : {};
  useEffect(() => {
    if (user.colors) {
      if (
        (user.colors && user.colors.preset !== "Classic" && !localStorage.getItem("mainColor")) ||
        user.colors.mainColor !== localStorage.getItem("mainColor")
      ) {
        localStorage.setItem("mainColor", user.colors.mainColor);
        localStorage.setItem("mainTextColor", user.colors.mainTextColor);
        localStorage.setItem("secondaryColor", user.colors.secondaryColor);
        localStorage.setItem("secondaryTextColor", user.colors.secondaryTextColor);
        localStorage.setItem("adColor", user.colors.adColor);
        localStorage.setItem("adTextColor", user.colors.adTextColor);
        localStorage.setItem("preset", user.colors.preset);
      }
    }
  }, [user]);

  return (
    <div className="App">
      <EmotionThemeProvider theme={theme}>
        <ThemeProvider theme={theme}>
          <StripeProvider apiKey="pk_live_8DmLDMDOXoT4jt9QG4OS3emh">
            <Layout>
              <Header />
              <main>
                <ToastContainer position="top-center" autoClose={2000} />
                <Routes />
              </main>
              <Footer footerData={headerData.footerItems} expanded={expanded} />
            </Layout>
          </StripeProvider>
        </ThemeProvider>
      </EmotionThemeProvider>
    </div>
  );
}
